import Form from '@utils/form'
import options from './config/option'

export default new Form('barcode.barfactor')
  .url('/srmBarcodeFactor/addSrmBarcodeFactor', process.env.VUE_APP_BASE_DATA_API)
  .title('formTitle.baseInfo')
  .add('codingId').required()
  .add('codingName')
  .add('parameter').required()
  .add('instruction')
  .add('status').op(options).required()
  .add('remarks').merge('textarea')
  .end()
